module.exports = __webpack_public_path__ + "static/1-67d365da804bb198e33a1e25411a9f17.jpg";